import React from 'react';

const BADGE_COLORS = {
  a_venir: '#3b82f6',
  en_cours: '#f59e0b',
  completee: '#10b981',
  annulee: '#6b7280',
};

const BADGE_LABELS = {
  a_venir: 'A venir',
  en_cours: 'En cours',
  completee: 'Completee',
  annulee: 'Annulee',
};

export default function MissionCard({ mission, onClick }) {
  const statut = mission.statut || '';
  const bg = BADGE_COLORS[statut] || '#6b7280';
  const label = BADGE_LABELS[statut] || statut;

  return (
    <div
      className="mission-card"
      onClick={() => onClick(mission)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick(mission);
        }
      }}
    >
      <div className="mission-header">
        <h3 className="mission-title">{mission.numero_rapport || 'Mission ' + mission.id}</h3>
        <span className="mission-badge" style={{ backgroundColor: bg }}>
          {label}
        </span>
      </div>

      <div className="mission-body">
        <p className="mission-client">
          <strong>{mission.client_nom}</strong>
        </p>
        <p className="mission-etablissement">{mission.etablissement}</p>
        <p className="mission-adresse">{mission.site_adresse}</p>
        <p className="mission-date">
          {mission.date_inspection
            ? new Date(mission.date_inspection).toLocaleDateString('fr-FR')
            : 'Date non definie'}
        </p>
      </div>
    </div>
  );
}
